import { useFlags } from 'launchdarkly-react-client-sdk';
import { PermissionKey } from '../../../services/PermissionAndRolesKeys';
import { PermissionService } from '../../../services/PermissionService';
import { MaggieFeatureFlags } from '../../../util/feature-flags';

/**
 * Single gating site for the Round Generation page, shared by the route, the nav item and the
 * Round Management tab. Customer success only for release 1; the flag turns it on per environment.
 */
export function useRoundCreationAvailable(): boolean {
  const { showRoundCreationConfig } = useFlags<MaggieFeatureFlags>();
  return (
    Boolean(showRoundCreationConfig) &&
    PermissionService.get().hasPermission(PermissionKey.customerSuccessAll)
  );
}
